<div class="w-full">
  @if (!isLoading) {
  <div class="flex border border-[#63AE81] rounded-full px-[4px] py-[3px]" [ngClass]="{
         'bg-white': style == 'white'
       }">
    @for (tab of tabs; track tab; let i = $index) {
    <div (click)="selectTab(i)" [ngClass]="[
               tab.tailwindClasses,
               activeTab === i ? ' text-white bg-[#0F8A6D]' : 'text-[#232626]',
               tab.border
             ]" [ngStyle]="{ width: tab.width, height: tab.height }"
      class="cursor-pointer flex items-center justify-center py-[5.5px] px-3 text-center leading-normal transition-all duration-200">

      @if (tab.icon) {
      <i [class]="tab.icon"></i> <!-- Optional icon -->
      }
      <span class="mb-0.5">{{ tab.label | translate: tab.labelPayload }}</span>
    </div>
    }
  </div>
  }
  @if (isLoading) {
  <vw-skeleton-loader [width]="'100%'" [height]="'40px'" [borderRadius]="'2rem'"></vw-skeleton-loader>
  }

  <!-- Content projection for tab content -->
  @if (!isLoading) {
  <div class="mt-6">
    <ng-content></ng-content>
  </div>
  }
</div>